import { Button } from '@slal/ui/buttons';
import { Modal, ModalBody, ModalFooter } from '@slal/ui/modal';
import { Article, Li, P, Ul } from '@slal/ui/typography';
import { useCallback, useState } from 'react';
import { StyledNotification } from './styles';

export const EmergencyTax = () => {
    const [isModalopen, setIsModalOpen] = useState(false);
    const closeModal = useCallback(() => setIsModalOpen(false), [setIsModalOpen]);
    const openModal = useCallback(() => setIsModalOpen(true), [setIsModalOpen]);

    return (
        <>
            <StyledNotification level="warning" aria-label="Emergency Tax">
                <P>
                    As you're taking more than your 25% tax-free cash, you're likely to pay emergency tax. Any overpaid
                    tax can be reclaimed later.
                </P>
                <P>It will also restrict how much you can pay into your pension.</P>
                <Button variant="outline" onClick={openModal}>
                    Learn more
                </Button>
            </StyledNotification>
            <Modal isOpen={isModalopen} onClose={closeModal} title="Taking a lump sum greater than your tax-free cash?">
                <ModalBody>
                    <Article>
                        <P>
                            You can normally take the first 25% of your pension pot tax-free. Taking anything over 25%
                            of your savings pot is subject to tax. HMRC have instructed us to apply an emergency tax
                            code to payments like this.
                        </P>
                        <P>
                            For most people Emergency tax means paying more tax on your first withdrawal afterwards HMRC
                            will correct this by taking less tax on later payments.
                        </P>
                        <P markdown>
                            If you don't want to wait for HMRC to do their corrections read our [Reclaiming tax
                            guide](https://www.standardlife.co.uk/retirement/guides/tax-back-pension-lump-sum).
                        </P>
                        <P>
                            When you take more than the tax-free cash, the maximum that you or an employer can pay into
                            any of your defined contribution pensions without attracting a tax charge will reduce to
                            £10,000 a year with no carry forward.
                        </P>
                        <P>This can be a problem if you are still earning and:</P>
                        <Ul>
                            <Li>have other savings you want to pay into your pension for a tax uplift,</Li>
                            <Li>significant pension contributions are likely in the future</Li>
                        </Ul>
                        <P>
                            Check this allowance isn't going to be a problem before going ahead. Once the allowance
                            reduces you can't change your mind later.
                        </P>
                        <P>
                            If your pension has a value of £10,000 or less, you may be able to avoid this if you cash in
                            the pension fully. You have a 'small pots' allowance where you can fully cash in up to three
                            personal pensions of £10,000 or less without this affecting how much you can pay into any of
                            your pensions. Note that some company pensions don't count towards the three.
                        </P>
                    </Article>
                </ModalBody>
                <ModalFooter>
                    <Button variant="solid" color="secondary" onClick={closeModal}>
                        Close
                    </Button>
                </ModalFooter>
            </Modal>
        </>
    );
};
